import React, { useState, useEffect } from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Grid, 
  Paper, 
  Button, 
  Breadcrumbs,
  Link as MuiLink,
  Tabs,
  Tab,
  Divider,
  List,
  ListItem,
  ListItemText,
  Rating,
  Chip,
  TextField,
  InputAdornment,
  IconButton,
  Card,
  CardMedia,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Snackbar,
  Alert,
  Stack,
  Badge,
  Avatar,
  Tooltip,
  LinearProgress,
  Fade,
  Popover,
  ListItemIcon
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { 
  ShoppingCart as CartIcon,
  Favorite as FavoriteIcon,
  Share as ShareIcon,
  Add as AddIcon,
  Remove as RemoveIcon,
  Store as StoreIcon,
  LocalShipping as ShippingIcon,
  AccessTime as TimeIcon,
  Verified as VerifiedIcon,
  AccessTime,
  Home as HomeIcon,
  Star as StarIcon,
  Facebook as FacebookIcon,
  Twitter as TwitterIcon,
  WhatsApp as WhatsAppIcon,
  ContentCopy as CopyIcon,
  Email as EmailIcon,
  Telegram as TelegramIcon
} from '@mui/icons-material';
import { Link, useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useCart } from '../contexts/CartContext';
import { convertEnglishToBengali, convertBengaliToEnglish } from '../utils/priceUtils';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Styled Components
const ProductImageCard = styled(Card)(({ theme }) => ({
  borderRadius: '4px',
  overflow: 'hidden',
  boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
  border: '1px solid rgba(0,0,0,0.05)',
  '& .MuiCardMedia-root': {
    transition: 'transform 0.5s ease',
  },
  '&:hover .MuiCardMedia-root': {
    transform: 'scale(1.05)',
  }
}));

const ProductInfoCard = styled(Paper)(({ theme }) => ({
  borderRadius: '4px',
  padding: theme.spacing(4),
  background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
  boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
  border: '1px solid rgba(0,0,0,0.05)',
}));

const PriceBox = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  color: 'white',
  borderRadius: '4px',
  padding: theme.spacing(1.5),
  textAlign: 'center',
}));

const StyledChip = styled(Chip)(({ theme }) => ({
  borderRadius: '4px',
  fontWeight: 600,
  padding: theme.spacing(0.5, 1),
  '&.MuiChip-colorPrimary': {
    background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
    color: 'white',
  },
  '&.MuiChip-colorSuccess': {
    background: 'linear-gradient(45deg, #4CAF50 30%, #45a049 90%)',
    color: 'white',
  },
}));

const QuantityBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
  borderRadius: '4px',
  padding: theme.spacing(0.5),
  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
  border: '1px solid rgba(0,0,0,0.05)',
  position: 'relative',
  overflow: 'visible',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: -1,
    left: -1,
    right: -1,
    bottom: -1,
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    borderRadius: '4px',
    zIndex: -1,
    opacity: 0,
    transition: 'opacity 0.3s ease',
  },
  '&:hover::before': {
    opacity: 0.1,
  },
  '& .MuiIconButton-root': {
    width: 44,
    height: 44,
    borderRadius: '4px',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    margin: 0,
    boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      background: 'linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%)',
      transform: 'translateY(-1px) scale(1.05)',
      boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
    },
    '&:active': {
      transform: 'translateY(0) scale(0.98)',
    },
    '&:disabled': {
      background: 'linear-gradient(135deg, #e2e8f0 0%, #cbd5e0 100%)',
      color: theme.palette.grey[500],
      transform: 'none',
      boxShadow: 'none',
      cursor: 'not-allowed',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '1.2rem',
      fontWeight: 'bold',
    }
  },
  '& .MuiTextField-root': {
    margin: '0 12px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '4px',
      backgroundColor: 'white',
      border: 'none',
      boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.06)',
      transition: 'all 0.3s ease',
      '&:hover': {
        boxShadow: 'inset 0 2px 8px rgba(0,0,0,0.1)',
      },
      '&.Mui-focused': {
        boxShadow: 'inset 0 2px 8px rgba(102, 126, 234, 0.2)',
        backgroundColor: '#fafbfc',
      },
      '& fieldset': {
        border: 'none',
      },
      '& input': {
        padding: theme.spacing(1.5),
        textAlign: 'center',
        fontSize: '1.1rem',
        fontWeight: '700',
        color: theme.palette.primary.main,
        userSelect: 'none',
        '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
          '-webkit-appearance': 'none',
          margin: 0,
        },
        '&[type=number]': {
          '-moz-appearance': 'textfield',
        }
      }
    }
  }
}));

const ActionButton = styled(Button)(({ theme }) => ({
  borderRadius: '4px',
  padding: theme.spacing(1.5, 3),
  fontWeight: 700,
  fontSize: '1.1rem',
  textTransform: 'none',
  boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 12px 35px rgba(0,0,0,0.2)',
  },
  '&.MuiButton-contained': {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    '&:hover': {
      background: 'linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%)',
    }
  }
}));

const StoreCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2),
  borderRadius: '4px',
  background: 'linear-gradient(135deg, rgba(33, 150, 243, 0.1) 0%, rgba(156, 39, 176, 0.1) 100%)',
  border: '1px solid rgba(33, 150, 243, 0.2)',
  transition: 'all 0.3s ease',
  cursor: 'pointer',
  '&:hover': {
    background: 'linear-gradient(135deg, rgba(33, 150, 243, 0.15) 0%, rgba(156, 39, 176, 0.15) 100%)',
    transform: 'translateY(-2px)',
    boxShadow: '0 8px 25px rgba(33, 150, 243, 0.2)',
  }
}));

const ImageThumbnail = styled(Box)(({ theme, active }) => ({
  width: 80,
  height: 80,
  borderRadius: '4px',
  overflow: 'hidden',
  cursor: 'pointer',
  border: active ? '3px solid' : '2px solid',
  borderColor: active ? theme.palette.primary.main : theme.palette.grey[300],
  transition: 'all 0.3s ease',
  position: 'relative',
  '&:hover': {
    borderColor: theme.palette.primary.main,
    transform: 'scale(1.05)',
  },
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  ...(active && {
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(33, 150, 243, 0.2)',
    }
  })
}));

const SingleProduct = () => {
  const { id } = useParams();
  const { addToCart } = useCart();
  const [tabValue, setTabValue] = useState(0);
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [quantity, setQuantity] = useState(1);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showReviewForm, setShowReviewForm] = useState(false);
  const [reviewRating, setReviewRating] = useState(5);
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  // Mock data for daily bazar product details
  useEffect(() => {
    // In a real app, this would be an API call
    setTimeout(() => {
      setProduct({
        id: parseInt(id),
        name: `${id === '1' ? 'পদ্মা নদির ফ্রেশ ইলিশ মাছ' : id === '2' ? 'জৈব চাল' : 'খামারের তাজা ডিম'}`,
        description: 'বিশ্বস্ত সরবরাহকারীদের কাছ থেকে সরাসরি সংগৃহীত প্রিমিয়াম মানের দৈনন্দিন প্রয়োজনীয় পণ্য। আমাদের পণ্যগুলি সর্বোত্তম মান এবং সতেজতা নিশ্চিত করার জন্য যত্নসহকারে নির্বাচিত। আপনার দৈনন্দিন রান্নার প্রয়োজনের জন্য উপযুক্ত।',
        price: 450,
        salePrice: 400,
        unit: id === '1' ? 'কেজি' : id === '2' ? 'কেজি' : 'ডজন',
        rating: 4.8,
        reviewCount: 125,
        stock: 30,
        images: [
          `https://source.unsplash.com/random/600x400?${id === '1' ? 'fish' : id === '2' ? 'rice' : 'eggs'}&sig=1`,
          `https://source.unsplash.com/random/600x400?${id === '1' ? 'fish' : id === '2' ? 'rice' : 'eggs'}&sig=2`,
          `https://source.unsplash.com/random/600x400?${id === '1' ? 'fish' : id === '2' ? 'rice' : 'eggs'}&sig=3`,
        ],
        store: {
          id: 1,
          name: 'দয়াল সুপারশপ',
          slug: 'dayaal-supershop',
          rating: 4.7,
          isVerified: true
        },
        bazar: {
          id: 1,
          name: 'চাঁচকৈর বাজার'
        },
        category: 'মাছ মাংস',
        freshness: 'একই দিন',
        deliveryTime: '৩০-৬০ মিনিট',
        minOrder: 1,
        attributes: [
          { name: 'উৎপত্তি', value: 'স্থানীয়' },
          { name: 'মান', value: 'প্রিমিয়াম' },
          { name: 'সংরক্ষণ', value: 'ফ্রিজে রাখুন' },
          { name: 'প্যাকেজিং', value: 'স্বাস্থ্যকর প্যাকেজিং' }
        ]
      });
      
      setLoading(false);
    }, 500);
  }, [id]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleQuantityChange = (event) => {
    const value = parseInt(event.target.value);
    if (!isNaN(value) && value > 0 && value <= product.stock) {
      setQuantity(value);
    }
  };

  const increaseQuantity = () => {
    if (quantity < product.stock) {
      setQuantity(quantity + 1);
    }
  };

  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const handleAddToCart = () => {
    addToCart(
      { 
        id: product.id, 
        name: product.name, 
        price: product.salePrice || product.price,
        image: product.images[0],
        store: product.store.name,
        stock: product.stock
      }, 
      quantity
    );
    
    setSnackbar({
      open: true,
      message: `${product.name} কার্টে যোগ করা হয়েছে!`,
      severity: 'success'
    });
    
    setTimeout(() => {
      setSnackbar(prev => ({...prev, open: false}));
    }, 3000);
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({...prev, open: false}));
  };

  const handleWriteReviewClick = () => {
    setShowReviewForm(!showReviewForm);
    if (!showReviewForm) {
      setReviewRating(5); // Reset rating when opening form
    }
  };

  const handleReviewSubmit = (reviewData) => {
    console.log('Review submitted:', { ...reviewData, rating: reviewRating });
    setSnackbar({
      open: true,
      message: `আপনার ${reviewRating} স্টার রিভিউ সফলভাবে জমা দেওয়া হয়েছে!`,
      severity: 'success'
    });
    setShowReviewForm(false);
    setReviewRating(5); // Reset rating after submit
  };

  const handleShareClick = (event) => {
    setShareAnchorEl(event.currentTarget);
  };

  const handleShareClose = () => {
    setShareAnchorEl(null);
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setSnackbar({
        open: true,
        message: 'লিংক কপি করা হয়েছে!',
        severity: 'success'
      });
    } catch (err) {
      setSnackbar({
        open: true,
        message: 'লিংক কপি করতে সমস্যা হয়েছে',
        severity: 'error'
      });
    }
    setShareAnchorEl(null);
  };

  const shareOptions = [
    {
      name: 'ফেসবুক',
      icon: <FacebookIcon sx={{ color: '#1877f2' }} />,
      action: () => {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`, '_blank');
        setShareAnchorEl(null);
      }
    },
    {
      name: 'হোয়াটসঅ্যাপ',
      icon: <WhatsAppIcon sx={{ color: '#25d366' }} />,
      action: () => {
        window.open(`https://wa.me/?text=${encodeURIComponent(`${product.name} - ${window.location.href}`)}`, '_blank');
        setShareAnchorEl(null);
      }
    },
    {
      name: 'টুইটার',
      icon: <TwitterIcon sx={{ color: '#1da1f2' }} />,
      action: () => {
        window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(`${product.name} - ${window.location.href}`)}`, '_blank');
        setShareAnchorEl(null);
      }
    },
    {
      name: 'টেলিগ্রাম',
      icon: <TelegramIcon sx={{ color: '#0088cc' }} />,
      action: () => {
        window.open(`https://t.me/share/url?url=${encodeURIComponent(window.location.href)}&text=${encodeURIComponent(product.name)}`, '_blank');
        setShareAnchorEl(null);
      }
    },
    {
      name: 'ইমেইল',
      icon: <EmailIcon sx={{ color: '#ea4335' }} />,
      action: () => {
        window.open(`mailto:?subject=${encodeURIComponent(product.name)}&body=${encodeURIComponent(`চেক করুন: ${product.name} - ${window.location.href}`)}`, '_blank');
        setShareAnchorEl(null);
      }
    },
    {
      name: 'লিংক কপি করুন',
      icon: <CopyIcon sx={{ color: '#666' }} />,
      action: handleCopyLink
    }
  ];

  if (loading) {
    return (
      <>
        <Header />
        <Container maxWidth="lg" sx={{ mt: 4, mb: 8, minHeight: '60vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Typography>পণ্যের বিবরণ লোড হচ্ছে...</Typography>
        </Container>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <Container maxWidth="xl" sx={{ mt: 4, mb: 8 }}>
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 3 }}>
          <MuiLink 
            component={Link} 
            to="/" 
            color="inherit" 
            sx={{ 
              display: 'flex', 
              alignItems: 'center'
            }}
          >
            <HomeIcon sx={{ mr: 0.5 }} fontSize="small" />
            হোম
          </MuiLink>
          <MuiLink component={Link} to="/daily-bazar" color="inherit">
            নিত্যপণ্যের বাজার
          </MuiLink>
                      <MuiLink component={Link} to={`/bazars/${product.bazar.slug || 'chanchkoir-bazar'}`} color="inherit">
            {product.bazar.name}
          </MuiLink>
          <MuiLink component={Link} to={`/stores/${product.store.slug || product.store.id}`} color="inherit">
            {product.store.name}
          </MuiLink>
          <Typography color="text.primary">{product.name}</Typography>
        </Breadcrumbs>

        <Grid container spacing={6}>
          <Grid item xs={12} md={6}>
            <ProductImageCard sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <CardMedia
                component="img"
                height="400"
                image={`https://picsum.photos/600/400?random=${13 + currentImageIndex}`}
                alt={product.name}
                sx={{ flex: 1 }}
              />
              <Box sx={{ display: 'flex', p: 3, gap: 2, justifyContent: 'center' }}>
                {[0, 1, 2].map((index) => (
                  <ImageThumbnail
                    key={index}
                    active={index === currentImageIndex}
                    onClick={() => setCurrentImageIndex(index)}
                  >
                    <img
                      src={`https://picsum.photos/300/300?random=${index + 13}`}
                      alt={`${product.name} view ${index + 1}`}
                    />
                  </ImageThumbnail>
                ))}
              </Box>
            </ProductImageCard>
          </Grid>
          <Grid item xs={12} md={6}>
            <ProductInfoCard sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <Box sx={{ mb: 4 }}>
                <StyledChip label={product.category} color="primary" size="medium" sx={{ mb: 3 }} />
                <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 700, color: 'text.primary', mb: 2 }}>
                  {product.name}
                </Typography>
                <StoreCard component={Link} to={`/stores/${product.store.slug || product.store.id}`} sx={{ textDecoration: 'none', mb: 3 }}>
                  <Avatar sx={{ bgcolor: 'primary.main', mr: 2 }}>
                    <StoreIcon />
                  </Avatar>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
                      {product.store.name}
                      {product.store.isVerified && (
                        <Tooltip title="যাচাইকৃত দোকান">
                          <VerifiedIcon sx={{ ml: 1, fontSize: 20, color: '#2196f3' }} />
                        </Tooltip>
                      )}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
                      <Rating value={product.store.rating} precision={0.1} readOnly size="small" />
                      <Typography variant="body2" sx={{ ml: 1, color: 'text.secondary' }}>
                        ({convertEnglishToBengali(product.store.rating.toString())})
                      </Typography>
                    </Box>
                  </Box>
                </StoreCard>
              </Box>
              
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <Rating value={product.rating} precision={0.1} readOnly size="large" />
                <Typography variant="h6" sx={{ ml: 2, fontWeight: 600 }}>
                  {convertEnglishToBengali(product.rating.toString())}
                </Typography>
                <Typography variant="body1" sx={{ ml: 1, color: 'text.secondary' }}>
                  ({convertEnglishToBengali(product.reviewCount.toString())} রিভিউ)
                </Typography>
              </Box>

              <Grid container spacing={2} sx={{ mb: 4 }}>
                <Grid item xs={6}>
                                    <Box sx={{ 
                    display: 'flex', 
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: 'center',
                    textAlign: { xs: 'center', sm: 'left' },
                    p: 2,
                    bgcolor: 'success.50',
                    borderRadius: '4px',
                    border: '1px solid',
                    borderColor: 'success.200'
                  }}>
                    <TimeIcon sx={{ 
                      mr: { xs: 0, sm: 1.5 }, 
                      mb: { xs: 1, sm: 0 },
                      color: 'success.main', 
                      fontSize: 28 
                    }} />
                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        ডেলিভারি সময়
                      </Typography>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        {product.deliveryTime}
                  </Typography>
                </Box>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                                    <Box sx={{ 
                    display: 'flex', 
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: 'center',
                    textAlign: { xs: 'center', sm: 'left' },
                    p: 2,
                    bgcolor: 'info.50',
                    borderRadius: '4px',
                    border: '1px solid',
                    borderColor: 'info.200'
                  }}>
                    <ShippingIcon sx={{ 
                      mr: { xs: 0, sm: 1.5 }, 
                      mb: { xs: 1, sm: 0 },
                      color: 'info.main', 
                      fontSize: 28 
                    }} />
                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        সর্বনিম্ন অর্ডার
                      </Typography>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        {convertEnglishToBengali(product.minOrder.toString())} {product.unit}
                  </Typography>
                </Box>
                  </Box>
                </Grid>
              </Grid>
              
              <PriceBox sx={{ mb: 3 }}>
                {product.salePrice < product.price ? (
                  <>
                    <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>
                      ৳{convertEnglishToBengali(product.salePrice.toString())}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                                            <Typography variant="body1" sx={{ textDecoration: 'line-through', opacity: 0.7 }}>
                      ৳{convertEnglishToBengali(product.price.toString())}
                    </Typography>
                      <Chip 
                        label={`${convertEnglishToBengali(Math.round(((product.price - product.salePrice) / product.price) * 100).toString())}% ছাড়`}
                        size="small"
                        sx={{ bgcolor: '#ff4444', color: 'white', fontWeight: 600 }}
                      />
                    </Box>
                  </>
                ) : (
                  <Typography variant="h4" sx={{ fontWeight: 700 }}>
                    ৳{convertEnglishToBengali(product.price.toString())}
                  </Typography>
                )}
                <Typography variant="body1" sx={{ mt: 0.5, opacity: 0.9 }}>
                  প্রতি {product.unit}
                </Typography>
              </PriceBox>
              
              <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.6, color: 'text.secondary', mb: 3 }}>
                {product.description}
              </Typography>
              
              <Grid container spacing={3} sx={{ mb: 3 }}>
                <Grid item xs={12} md={6}>
                  <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                    স্টক:
                  </Typography>
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'space-between',
                    p: 2,
                    bgcolor: product.stock > 0 ? 'success.50' : 'error.50',
                    borderRadius: '4px',
                    border: '2px solid',
                    borderColor: product.stock > 0 ? 'success.200' : 'error.200'
                  }}>
                    <StyledChip 
                      label={product.stock > 0 ? 'স্টকে আছে' : 'স্টকে নেই'} 
                      color={product.stock > 0 ? 'success' : 'error'} 
                      size="medium" 
                    />
                                    {product.stock > 0 && (
                      <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'success.dark' }}>
                        {convertEnglishToBengali(product.stock.toString())} {product.unit}
                  </Typography>
                )}
                  </Box>
                </Grid>
                
                <Grid item xs={12} md={4}>
                  <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                    পরিমাণ নির্বাচন করুন:
                  </Typography>
                  <QuantityBox>
                    <IconButton onClick={decreaseQuantity} disabled={quantity <= 1}>
                      <RemoveIcon />
                    </IconButton>
                    <TextField
                      value={quantity}
                      onChange={handleQuantityChange}
                      inputProps={{ 
                        min: 1, 
                        max: product.stock,
                        type: 'number'
                      }}
                      sx={{ width: 70 }}
                      variant="outlined"
                      size="small"
                    />
                    <IconButton onClick={increaseQuantity} disabled={quantity >= product.stock}>
                      <AddIcon />
                    </IconButton>
                  </QuantityBox>
                  <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
                    মোট: ৳{convertEnglishToBengali(((product.salePrice || product.price) * quantity).toLocaleString())}
                  </Typography>
                </Grid>
              </Grid>
              
              <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                <ActionButton 
                  variant="contained"
                  size="large"
                  startIcon={<CartIcon />}
                  sx={{ 
                    flexGrow: 1,
                    '&:disabled': {
                      background: 'linear-gradient(135deg, #e2e8f0 0%, #cbd5e0 100%) !important',
                      color: '#64748b'
                    }
                  }}
                  onClick={handleAddToCart}
                  disabled={product.stock === 0}
                >
                  {product.stock > 0 ? 'ব্যাগে নিন' : 'স্টকে নেই'}
                </ActionButton>
                <Tooltip title="পছন্দের তালিকায় যোগ করুন">
                  <IconButton 
                    color="primary" 
                    sx={{ 
                      bgcolor: 'rgba(255, 107, 53, 0.1)',
                      border: '2px solid',
                      borderColor: 'primary.main',
                      borderRadius: '4px',
                      '&:hover': {
                        bgcolor: 'primary.main',
                        color: 'white',
                        transform: 'scale(1.1)'
                      }
                    }}
                  >
                    <FavoriteIcon />
                  </IconButton>
                </Tooltip>
                                <Tooltip title="শেয়ার করুন">
                  <IconButton 
                    color="primary"
                    onClick={handleShareClick}
                    sx={{ 
                      bgcolor: 'rgba(255, 107, 53, 0.1)',
                      border: '2px solid',
                      borderColor: 'primary.main',
                      borderRadius: '4px',
                      '&:hover': {
                        bgcolor: 'primary.main',
                        color: 'white',
                        transform: 'scale(1.1)'
                      }
                    }}
                  >
                  <ShareIcon />
                </IconButton>
                </Tooltip>
              </Box>
            </ProductInfoCard>
          </Grid>
        </Grid>

        {/* Share Popup */}
        <Popover
          open={Boolean(shareAnchorEl)}
          anchorEl={shareAnchorEl}
          onClose={handleShareClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          disableScrollLock={true}
          disableRestoreFocus={true}
          PaperProps={{
            sx: {
              borderRadius: '4px',
              boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
              border: '1px solid rgba(0,0,0,0.05)',
              mt: 1,
              minWidth: 280
            }
          }}
          sx={{
            '& .MuiPopover-root': {
              position: 'absolute',
            }
          }}
        >
          <Box sx={{ p: 2 }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: 'primary.main', textAlign: 'center' }}>
              শেয়ার করুন
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <List sx={{ p: 0 }}>
              {shareOptions.map((option, index) => (
                <ListItem
                  key={index}
                  button
                  onClick={option.action}
                  sx={{
                    borderRadius: '4px',
                    mb: 1,
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      bgcolor: 'primary.50',
                      transform: 'translateX(4px)',
                    },
                    '&:last-child': {
                      mb: 0
                    }
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 40 }}>
                    {option.icon}
                  </ListItemIcon>
                  <ListItemText 
                    primary={option.name}
                    primaryTypographyProps={{
                      fontWeight: 500,
                      fontSize: '0.95rem'
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </Box>
        </Popover>

        <Paper sx={{ 
          mt: 6, 
          borderRadius: '4px',
          overflow: 'hidden',
          boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
          border: '1px solid rgba(0,0,0,0.05)'
        }}>
          <Tabs 
            value={tabValue} 
            onChange={handleTabChange}
            variant="fullWidth"
            textColor="primary"
            indicatorColor="primary"
            sx={{
              bgcolor: 'grey.50',
              '& .MuiTab-root': {
                fontWeight: 600,
                fontSize: '1.1rem',
                textTransform: 'none',
                py: 2,
                transition: 'all 0.3s ease',
                '&:hover': {
                  bgcolor: 'primary.50',
                  color: 'primary.main'
                },
                '&.Mui-selected': {
                  bgcolor: 'white',
                  color: 'primary.main',
                  fontWeight: 700
                }
              },
              '& .MuiTabs-indicator': {
                height: 4,
                borderRadius: '4px',
                background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)'
              }
            }}
          >
            <Tab label="পণ্যের বিবরণ" />
            <Tab label="স্পেসিফিকেশন" />
            <Tab label="কাস্টমার রিভিউ" />
          </Tabs>
          <Box sx={{ p: 4 }}>
            {tabValue === 0 && (
              <Fade in={tabValue === 0} timeout={500}>
                <Box>
                  <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, color: 'primary.main', mb: 3 }}>
                    পণ্যের বিস্তারিত বিবরণ
                  </Typography>
                  <Paper sx={{ p: 3, bgcolor: 'grey.50', borderRadius: '4px', mb: 3 }}>
                    <Typography paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8, color: 'text.primary' }}>
                      {product.description}
                    </Typography>
                  </Paper>
                  
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <Box sx={{ p: 3, bgcolor: 'success.50', borderRadius: '4px', border: '1px solid', borderColor: 'success.200' }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: 'success.dark' }}>
                          🌱 মান নিশ্চয়তা
                        </Typography>
                        <Typography sx={{ color: 'text.secondary', lineHeight: 1.6 }}>
                          আমাদের পণ্যগুলি তাজা এবং মানসম্মত নিশ্চিত করার জন্য যত্নের সাথে নির্বাচন করা হয়। আমরা সেরা দৈনিক প্রয়োজনীয় পণ্য সরবরাহ করার জন্য বিশ্বস্ত সরবরাহকারীদের সাথে সরাসরি কাজ করি।
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box sx={{ p: 3, bgcolor: 'info.50', borderRadius: '4px', border: '1px solid', borderColor: 'info.200' }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: 'info.dark' }}>
                          🚚 দ্রুত ডেলিভারি
                        </Typography>
                        <Typography sx={{ color: 'text.secondary', lineHeight: 1.6 }}>
                          আমরা ন্যায্য মূল্যে মানসম্মত পণ্য সরবরাহ করতে বিশ্বাস করি। আপনি যখন আমাদের কাছ থেকে কেনাকাটা করেন, তখন আপনি আপনার দরজায় দ্রুত ডেলিভারির সুবিধা পাবেন।
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Fade>
            )}
            {tabValue === 1 && (
              <Fade in={tabValue === 1} timeout={500}>
                <Box>
                  <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, color: 'primary.main', mb: 3 }}>
                    পণ্যের স্পেসিফিকেশন
                  </Typography>
                  <TableContainer component={Paper} sx={{ borderRadius: '4px', overflow: 'hidden', boxShadow: 2 }}>
                    <Table>
                      <TableBody>
                        {product.attributes.map((attribute, index) => (
                          <TableRow 
                            key={index}
                            sx={{ 
                              '&:nth-of-type(odd)': { bgcolor: 'grey.50' },
                              '&:hover': { bgcolor: 'primary.50', transition: 'all 0.3s ease' }
                            }}
                          >
                            <TableCell 
                              component="th" 
                              scope="row" 
                              sx={{ 
                                width: '40%', 
                                fontWeight: 700, 
                                fontSize: '1.1rem',
                                color: 'primary.main',
                                py: 2
                              }}
                            >
                              {attribute.name}
                            </TableCell>
                            <TableCell sx={{ fontSize: '1rem', py: 2 }}>
                              {attribute.value}
                            </TableCell>
                          </TableRow>
                        ))}
                                                <TableRow sx={{ '&:nth-of-type(odd)': { bgcolor: 'grey.50' }, '&:hover': { bgcolor: 'primary.50' } }}>
                          <TableCell component="th" scope="row" sx={{ fontWeight: 700, fontSize: '1.1rem', color: 'primary.main', py: 2 }}>
                            একক
                          </TableCell>
                          <TableCell sx={{ fontSize: '1rem', py: 2 }}>{product.unit}</TableCell>
                        </TableRow>
                        <TableRow sx={{ '&:nth-of-type(odd)': { bgcolor: 'grey.50' }, '&:hover': { bgcolor: 'primary.50' } }}>
                          <TableCell component="th" scope="row" sx={{ fontWeight: 700, fontSize: '1.1rem', color: 'primary.main', py: 2 }}>
                          ডেলিভারি সময়
                        </TableCell>
                          <TableCell sx={{ fontSize: '1rem', py: 2 }}>{product.deliveryTime}</TableCell>
                      </TableRow>
                        <TableRow sx={{ '&:nth-of-type(odd)': { bgcolor: 'grey.50' }, '&:hover': { bgcolor: 'primary.50' } }}>
                          <TableCell component="th" scope="row" sx={{ fontWeight: 700, fontSize: '1.1rem', color: 'primary.main', py: 2 }}>
                          সর্বনিম্ন অর্ডার
                        </TableCell>
                          <TableCell sx={{ fontSize: '1rem', py: 2 }}>{convertEnglishToBengali(product.minOrder.toString())} {product.unit}</TableCell>
                      </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Fade>
            )}
            {tabValue === 2 && (
              <Fade in={tabValue === 2} timeout={500}>
                <Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                    <Typography variant="h5" sx={{ fontWeight: 700, color: 'primary.main' }}>
                      গ্রাহক রিভিউ ও মন্তব্য
                    </Typography>
                    <ActionButton
                      variant="contained"
                      startIcon={<StarIcon />}
                      onClick={handleWriteReviewClick}
                      sx={{
                        whiteSpace: 'nowrap',
                        minWidth: 'auto',
                        px: { xs: 2, sm: 3 },
                        fontSize: { xs: '0.9rem', sm: '1.1rem' },
                        ...(showReviewForm && {
                          background: 'linear-gradient(45deg, #f44336 30%, #d32f2f 90%) !important',
                          '&:hover': {
                            background: 'linear-gradient(45deg, #d32f2f 30%, #c62828 90%) !important',
                          }
                        })
                      }}
                    >
                      {showReviewForm ? 'বাতিল করুন' : 'রিভিউ লিখুন'}
                    </ActionButton>
                  </Box>
                  
                  <Paper sx={{ p: 3, mb: 3, bgcolor: 'primary.50', borderRadius: '4px', border: '1px solid', borderColor: 'primary.200' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
                      <Typography variant="h2" sx={{ fontWeight: 800, color: 'primary.main', mr: 2 }}>
                        {convertEnglishToBengali(product.rating.toString())}
                      </Typography>
                      <Box>
                        <Rating value={product.rating} precision={0.1} readOnly size="large" />
                                                <Typography variant="h6" sx={{ color: 'text.secondary' }}>
                  {convertEnglishToBengali(product.reviewCount.toString())} টি রিভিউ এর ভিত্তিতে
                </Typography>
                      </Box>
                    </Box>
                                        <LinearProgress 
                      variant="determinate" 
                      value={(product.rating / 5) * 100} 
                      sx={{ 
                        height: 8, 
                        borderRadius: '4px',
                        bgcolor: 'grey.200',
                        '& .MuiLinearProgress-bar': {
                          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          borderRadius: '4px'
                        }
                      }} 
                    />
                   </Paper>
                   
                   {/* Review Form - Between Rating and Reviews */}
                   {showReviewForm && (
                     <Fade in={showReviewForm} timeout={500}>
                       <Paper sx={{ 
                         p: 4, 
                         my: 3, 
                         bgcolor: 'grey.50', 
                         borderRadius: '4px', 
                         border: '2px solid', 
                         borderColor: 'primary.main',
                         boxShadow: '0 8px 32px rgba(33, 150, 243, 0.15)'
                       }}>
                         <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: 'primary.main', mb: 3 }}>
                           আপনার রিভিউ লিখুন
                         </Typography>
                         
                         <Grid container spacing={3}>
                           <Grid item xs={12} sm={6}>
                             <TextField
                               fullWidth
                               label="আপনার নাম"
                               variant="outlined"
                               sx={{ mb: 2 }}
                             />
                           </Grid>
                           <Grid item xs={12} sm={6}>
                             <Box>
                               <Typography variant="body2" gutterBottom sx={{ fontWeight: 600 }}>
                                 রেটিং দিন
                               </Typography>
                               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                                 <Rating
                                   value={reviewRating}
                                   onChange={(event, newValue) => {
                                     setReviewRating(newValue);
                                   }}
                                   precision={0.1}
                                   size="large"
                                   sx={{ 
                                     '& .MuiRating-iconFilled': {
                                       color: '#ff6d75'
                                     },
                                     '& .MuiRating-iconHover': {
                                       color: '#ff3d47'
                                     }
                                   }}
                                 />
                                 <Typography variant="h6" sx={{ fontWeight: 600, color: 'primary.main', ml: 1 }}>
                                   {convertEnglishToBengali(reviewRating ? reviewRating.toFixed(1) : '0.0')}
                                 </Typography>
                               </Box>
                               <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                                 সুনির্দিষ্ট রেটিং দিতে তারকার উপর মাউস ঘুরান
                               </Typography>
                             </Box>
                           </Grid>
                           <Grid item xs={12}>
                             <TextField
                               fullWidth
                               label="আপনার মন্তব্য"
                               multiline
                               rows={4}
                               variant="outlined"
                               placeholder="এই পণ্য সম্পর্কে আপনার অভিজ্ঞতা শেয়ার করুন..."
                               sx={{ mb: 3 }}
                             />
                           </Grid>
                         </Grid>
                         
                         <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                           <Button
                             variant="outlined"
                             onClick={() => setShowReviewForm(false)}
                             sx={{ 
                               borderRadius: '4px', 
                               px: { xs: 2, sm: 3 },
                               whiteSpace: 'nowrap',
                               fontSize: { xs: '0.9rem', sm: '1rem' },
                               minWidth: 'auto'
                             }}
                           >
                             বাতিল করুন
                           </Button>
                           <ActionButton
                             variant="contained"
                             onClick={() => handleReviewSubmit({})}
                             sx={{
                               background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                               whiteSpace: 'nowrap',
                               minWidth: 'auto',
                               px: { xs: 2, sm: 3 },
                               fontSize: { xs: '0.9rem', sm: '1.1rem' },
                               '&:hover': {
                                 background: 'linear-gradient(45deg, #1976D2 30%, #0288D1 90%)',
                               }
                             }}
                           >
                             রিভিউ জমা দিন
                           </ActionButton>
                         </Box>
                       </Paper>
                     </Fade>
                   )}
                   
                   <List sx={{ bgcolor: 'white', borderRadius: '4px' }}>
                    {[
                      { name: 'করিম আহমেদ', rating: 5, comment: 'খুব ভালো মানের পণ্য এবং দ্রুত ডেলিভারি! অবশ্যই আবার কিনবো।', time: 'দুই ঘন্টা আগে' },
                      { name: 'ফাতিমা সুলতানা', rating: 4, comment: 'তাজা পণ্য, যুক্তিসঙ্গত মূল্য। প্যাকেজিং ভালো ছিল।', time: 'একদিন আগে' },
                      { name: 'রহমান মিয়া', rating: 5, comment: 'মানের সাথে খুবই সন্তুষ্ট। ধন্যবাদ!', time: 'তিনদিন আগে' }
                    ].map((review, index) => (
                      <React.Fragment key={index}>
                        <ListItem sx={{ 
                          py: 3,
                          '&:hover': { 
                            bgcolor: 'grey.50',
                            transition: 'all 0.3s ease'
                          }
                        }}>
                          <Avatar sx={{ bgcolor: 'primary.main', mr: 2, width: 50, height: 50 }}>
                            {review.name.charAt(0)}
                          </Avatar>
                          <ListItemText 
                            primary={
                              <Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                  <Typography variant="h6" sx={{ fontWeight: 600, mr: 2 }}>
                                    {review.name}
                                  </Typography>
                                  <Rating value={review.rating} size="small" readOnly />
                                </Box>
                                <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.6 }}>
                                  "{review.comment}"
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                  {review.time}
                                </Typography>
                              </Box>
                            }
                          />
                        </ListItem>
                        {index < 2 && <Divider />}
                      </React.Fragment>
                                         ))}
                   </List>
                 </Box>
               </Fade>
             )}
          </Box>
        </Paper>

        <Box sx={{ mt: 8 }}>
          <Typography variant="h4" gutterBottom sx={{ 
            fontWeight: 700, 
            color: 'primary.main', 
            textAlign: 'center',
            mb: 4,
            position: 'relative',
            '&::after': {
              content: '""',
              position: 'absolute',
              bottom: -10,
              left: '50%',
              transform: 'translateX(-50%)',
              width: 80,
              height: 4,
              background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
              borderRadius: '4px'
            }
          }}>
            🛒 সম্পর্কিত পণ্যসমূহ
          </Typography>
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={24}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            breakpoints={{
              640: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              1024: { slidesPerView: 4 },
            }}
          >
            {[
              { name: 'তাজা মুরগি', store: 'দয়াল সুপারশপ', price: 280, originalPrice: 320, rating: 4.8 },
              { name: 'বাসমতি চাল', store: 'রহমান স্টোর', price: 120, originalPrice: 140, rating: 4.6 },
              { name: 'মিশ্র সবজি', store: 'ফ্রেশ ভেজি', price: 60, originalPrice: 70, rating: 4.7 },
              { name: 'গরুর দুধ', store: 'দুগ্ধ ফার্ম', price: 90, originalPrice: 100, rating: 4.9 }
            ].map((item, index) => (
              <SwiperSlide key={index}>
                <Card 
                  sx={{ 
                    height: '100%', 
                    display: 'flex', 
                    flexDirection: 'column',
                    borderRadius: '4px',
                    overflow: 'hidden',
                    border: '1px solid rgba(0,0,0,0.05)',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
                      '& .MuiCardMedia-root': {
                        transform: 'scale(1.1)',
                      }
                    },
                  }}
                >
                  <Box sx={{ position: 'relative', overflow: 'hidden' }}>
                    <CardMedia
                      component="img"
                      height="180"
                      image={`https://picsum.photos/300/200?random=${index + 20}`}
                      alt={item.name}
                      sx={{ transition: 'transform 0.3s ease' }}
                    />
                    <Chip
                      label={`${convertEnglishToBengali(Math.round(((item.originalPrice - item.price) / item.originalPrice) * 100).toString())}% ছাড়`}
                      color="error"
                      sx={{
                        position: 'absolute',
                        top: 12,
                        right: 12,
                        bgcolor: '#ff4444',
                        color: 'white',
                        fontWeight: 600,
                        fontSize: '0.75rem'
                      }}
                    />
                  </Box>
                  <CardContent sx={{ flexGrow: 1, p: 3 }}>
                    <Typography gutterBottom variant="h6" component="h3" sx={{ fontWeight: 600, mb: 1 }}>
                      {item.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" gutterBottom sx={{ mb: 2 }}>
                      {item.store}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Rating value={item.rating} precision={0.1} readOnly size="small" />
                      <Typography variant="body2" sx={{ ml: 1, color: 'text.secondary' }}>
                        ({convertEnglishToBengali(item.rating.toString())})
                      </Typography>
                    </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                      <Typography variant="h6" color="primary" sx={{ fontWeight: 700 }}>
                        ৳{convertEnglishToBengali(item.price.toString())}
                      </Typography>
                      <Typography variant="body2" sx={{ textDecoration: 'line-through', color: 'text.secondary' }}>
                        ৳{convertEnglishToBengali(item.originalPrice.toString())}
                    </Typography>
                    </Box>
                  </CardContent>
                  <Box sx={{ p: 3, pt: 0 }}>
                    <ActionButton 
                      size="small" 
                      variant="contained" 
                      fullWidth
                      startIcon={<CartIcon />}
                      sx={{ 
                        fontSize: '0.9rem',
                        py: 1.2
                      }}
                    >
                      কার্টে যোগ করুন
                    </ActionButton>
                  </Box>
                </Card>
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      </Container>
      <Footer />
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default SingleProduct; 